import React, { FC, useContext } from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import translations_sv from '../../Translations/sv.json';
import translations_en from '../../Translations/en.json';
import { UserContext } from '../../Context/UserContext/UserContext';
interface IProps {
    children:React.ReactNode 
}
export const IntlProvider: FC<IProps> = ({ children }) => {
  const messages = {
    sv: translations_sv,
    en: translations_en,
  };
  const user = useContext(UserContext);
  return (
    <ReactIntlProvider locale='en' messages={messages[user.locale]}>
      {children}
    </ReactIntlProvider>
  );
};